import { createStore } from 'vuex'

const state = () => ({
  currentStep: -1,
})

const mutations = {
  SET_STEP(state, stepNumber) {
    state.currentStep = stepNumber
  },
}

const getters = {
  getCurrentStep(state) {
    return state.currentStep
  },
}

export default {
  state,
  getters,
  mutations,
}

export const useSteps = createStore({
  state,
  getters,
  mutations,
})
